import {
  Module,
  VuexModule,
  MutationAction,
  Mutation,
  Action,
} from 'vuex-module-decorators';
import { Auction, Lot, Bid, Wish } from '@/api';
import { authModule } from './index';
import { Vue } from 'vue-property-decorator';

@Module({
  name: 'AuctionModule',
  namespaced: true,
})
export default class AuctionModule extends VuexModule {
  wishes: { [key: string]: { [key: string]: Wish } } = {};

  bids: { [key: string]: { [key: string]: Bid } } = {};

  @Action({ rawError: true })
  async checkAuctionWishes(auctionId: string) {
    if (!authModule.user) {
      return;
    }
    const auctionWishes = this.wishes[auctionId];
    if (!auctionWishes) {
      Vue.set(this.wishes, auctionId, {});
      try {
        const scope = Wish.includes(['lot.auction']);
        const wishes = (
          await scope
            .per(2000)
            .where({ 'lot.auction': auctionId, user: authModule.user.id })
            .all()
        ).data;
        wishes.forEach(w => {
          if (!w.lot.id) {
            return;
          }
          Vue.set(this.wishes[auctionId], w.lot.id, w);
        });
      } catch (e) {
        throw e;
      }
    }
  }

  @Action({ rawError: true })
  async checkAuctionBids(auctionId: string) {
    if (!authModule.user) {
      return;
    }
    const auctionBids = this.bids[auctionId];
    if (!auctionBids) {
      Vue.set(this.bids, auctionId, {});
      try {
        const scope = Bid.includes(['lot.auction']);
        const bids = (
          await scope
            .per(2000)
            .where({ 'lot.auction': auctionId, user: authModule.user.id })
            .all()
        ).data;
        bids.forEach(b => {
          if (!b.lot.id) {
            return;
          }
          Vue.set(this.bids[auctionId], b.lot.id, b);
        });
      } catch (e) {
        throw e;
      }
    }
  }

  @Action({ rawError: true })
  async addWish(lot: Lot) {
    if (!authModule.user || !lot.id || !lot.auction.id) {
      return;
    }
    const wish = new Wish();
    wish.user = authModule.user;
    wish.lot = lot;

    try {
      await wish.save({ with: ['lot.id', 'user.id'] });
      Vue.set(this.wishes[lot.auction.id], lot.id, wish);
    } catch (err) {
      // Error
    }
  }

  @Action({ rawError: true })
  async addBid({ lot, value }: { lot: Lot; value: number }) {
    if (!authModule.user || !lot.id || !lot.auction.id) {
      return;
    }
    const bid = new Bid();
    bid.user = authModule.user;
    bid.lot = lot;
    bid.value = value;

    try {
      await bid.save({ with: ['lot.id', 'user.id'] });
      Vue.set(this.bids[lot.auction.id], lot.id, bid);
    } catch (err) {
      throw err;
      // Error
    }
  }

  @Action({ rawError: true })
  async removeWish(lot: Lot) {
    if (!authModule.user || !lot.id || !lot.auction.id) {
      return;
    }
    const wish = this.wishes[lot.auction.id][lot.id];
    if (wish) {
      try {
        await wish.destroy();
        Vue.delete(this.wishes[lot.auction.id], lot.id);
      } catch (err) {
        // Error
      }
    }
  }
}
